<template>
  <div>
    <header>
      <!-- Custom CSS -->
      <link rel="stylesheet" href="../../../public/portal-api/css/style.css">
      <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
        integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
    </header>

    <section class="banner">
      <div class="subtitle-container mt-5 ml-5">
        <h3 class="title mb-5" style="top: -3px; position: relative; text-align: center;">
          <span>BEM VINDO(A) AO</span></br>PORTAL DE INTEGRAÇÕES & API
        </h3>
      </div>
    </section>

    <section class="cards">
      <div class="container">
        <div class="row g-1 d-flex justify-content-between">


          <div style="height: 350px;width: 360px !important;" class="card d-flex justify-content-center">
            <div class="card-body">
              <h5 class="card-completed-title">INTEGRAÇÕES CONCLUÍDAS</h5>

              <div class="linha"></div>

              <div class="father-div-progress mt-4">
                <div model="selectedListaConcluidas" v-for="concluida in this.listaConcluidas"
                  :key="concluida.codigoProduto" :value="concluida.codigo">
                  <!-- Card interno -->
                  <div>
                    <div class="card-intern">
                      <div class="card-icons">
                        <div class="">

                          <i class="icon-line" v-if="concluida != undefined && iconFor(concluida)">
                            <img class="card-img" :class="safeIcon(concluida).customClass || ''"
                              :src="`/massificados/corporativo/gerenciador-parceiros-ui/${iconFor(concluida).path || 'consulta'}/img/${iconFor(concluida).img}`">
                            <p class="card-text mt-1 card-img-text">
                              {{ iconFor(concluida).label }}
                            </p>
                          </i>

                          <!-- 
                        <i v-if="concluida.codigoProduto === 7" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_carro.svg">
                          <p class="card-text mt-1 card-img-text"><small>AUTOMÓVEL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 14" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_residencial.svg">
                          <p class="card-text mt-1 card-img-text"><small>RESIDENCIAL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 43 || concluida.codigoProduto === 44" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_imobiliario.svg">
                          <p class="card-text mt-1 card-img-text"><small>IMOBILIÁRIO</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 12" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_condominio.svg">
                          <p class="card-text mt-1 card-img-text"><small>CONDOMÍNIO</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 47" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_vida.svg">
                          <p class="card-text mt-1 card-img-text"><small>VIDA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 55 || concluida.codigoProduto === 56  || concluida.codigoProduto === 72  || concluida.codigoProduto === 73" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_aluguel.svg">
                          <p class="card-text mt-1 card-img-text"><small>ALUGUEL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 7503 || concluida.codigoProduto === 7602 || concluida.codigoProduto === 7603 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('GARANTIA'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_garantia.svg">
                          <p class="card-text mt-1 card-img-text"><small>GARANTIA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 62 || concluida.codigoProduto === 63 || (concluida.produto != undefined &&concluida.produto.toUpperCase().includes('EMPRESARIAL'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_empresarial.svg">
                          <p class="card-text mt-1 card-img-text"><small>EMPRESARIAL</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 103 || concluida.produto.toUpperCase().includes('AGRO SAFRA')" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_agro.svg">
                          <p class="card-text mt-1 card-img-text-safra"><small>AGRO SAFRA</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 10005 || concluida.codigoProduto === 10006 || concluida.codigoProduto === 10017 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('EQUIPAMENTOS'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_equipamentos.svg">
                          <p class="card-text mt-1 card-img-text"><small>EQUIPAMENTOS</small></p>
                        </i>
                        <i v-if="concluida.codigoProduto === 108 || (concluida.produto != undefined && concluida.produto.toUpperCase().includes('VIAGEM'))" class="icon-line">
                          <img class="card-img" src="/massificados/corporativo/gerenciador-parceiros-ui/consulta//massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/icon_viagem.svg">
                          <p class="card-text mt-1 card-img-text"><small>VIAGEM</small></p>
                        </i> -->
                        </div>
                      </div>

                      <div class="card-info">
                        <!-- <div  class="card-body"> -->
                        <h5 class="card-text">CORRETORES <br> INTEGRADOS:</h5>
                        <h5 class="card-text">
                          <span class="card-text">{{ concluida.qtd_corretor }}</span>
                        </h5>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="listaConcluidas.length == 0" class="msg-integracoes">A sua operadora não possui nenhuma
                  integração concluída!</div>
              </div>
            </div>
          </div>

          <div style="height: 350px;width: 360px !important;" class="card d-flex justify-content-center">
            <div class="card-body">
              <h5 class="card-progress-title">INTEGRAÇÕES EM ANDAMENTO</h5>

              <div class="linha"></div>

              <div class="father-div-progress mt-4">
                <div model="selectedListaConcluidas" v-for="itemEmAndamento in this.listaEmAndamento"
                  :key="itemEmAndamento.id" :value="itemEmAndamento.codigoOperadora">
                  <!-- Card interno -->
                  <div>
                    <div class="card-intern">
                      <div class="card-icons">
                        <div class="">
                          <!-- <i class="icon-line" v-for="icon in iconMap" :key="icon.key" v-if="itemEmAndamento.api != undefined && itemEmAndamento.api.toUpperCase().includes(icon.key)" >
                          <img class="card-img" 
                            :class="safeIcon(itemEmAndamento).customClass || ''"
                            :src="`/massificados/corporativo/gerenciador-parceiros-ui/${icon.path || 'consulta'}/img/${icon.img}`">
                          <p class="card-text mt-1 card-img-text">
                            <small>{{ icon.label }}</small>
                          </p>
                        </i> -->

                          <i class="icon-line" v-for="icon in iconsForApi(itemEmAndamento)" :key="icon.key">
                            <img class="card-img" :class="icon.customClass || ''"
                              :src="`/massificados/corporativo/gerenciador-parceiros-ui/${icon.path || 'consulta'}/img/${icon.img}`">
                            <p class="card-text mt-1 card-img-text">{{ icon.label }}</p>
                          </i>

                        </div>
                      </div>

                      <div class="card-info">

                        <h5 class="card-text" style="height: 7% !important;">
                          DATA:
                          <span class="card-text card-subtext">{{ formatarData(itemEmAndamento.dataCriacao) }}</span>
                        </h5>
                        <h5 v-for="situacao in situacaoMap" :key="situacao.key"
                          v-if="itemEmAndamento.situacao === situacao.key" class="card-text mt-2"
                          :style="situacao.style">
                          SITUAÇÃO:
                          <span class="card-text card-subtext" style="margin-top: 10% !important;">
                            {{ situacao.label }}
                          </span>
                        </h5>

                        <!-- <div style="margin-left: 1%;margin-top: -10px !important" class="card-body justify-content-center"> -->


                        <!-- <h5 class="card-text mt-2" style="height: 7% !important;">DATA:
                          <span class="card-text card-subtext">{{ formatarData(itemEmAndamento.dataCriacao) }}</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'APROVACAO-PRODUTOS'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -0px;width:140% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">APROVAÇÃO</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'CONFIGURACAO-ACEITE'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">CONFIGURAÇÃO ACEITE</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'DESENVOLVINENTO'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">DESENVOLVINENTO</span>
                        </h5>
                        <h5
                          v-if="itemEmAndamento.situacao === 'HOMOLOGACAO-TI' || itemEmAndamento.situacao === 'HOMOLOGACAO-PRODUTOS'"
                          class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -45px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">HOMOLOGAÇÃO</span>
                        </h5>
                        <h5 v-if="itemEmAndamento.situacao === 'CONFIGURACAO-PRODUCAO'" class="card-text mt-2"
                          style="margin-top: 10% !important;font-size: 10px; margin-left: -19px;width:150% !important">
                          SITUAÇÃO:
                          <span class="card-text card-subtext"
                            style="margin-top: 10% !important;font-size: 10px !important;">CONFIG. PRODUÇÃO</span>
                        </h5> 
                      </div>-->
                      </div>

                    </div>
                  </div>
                </div>
                <div v-if="listaEmAndamento.length == 0" class="msg-integracoes">A sua operadora não possui nenhuma
                  integração em andamento!</div>
              </div>

            </div>
          </div>

          <div class="card d-flex justify-content-center" style="height: 350px;width: 360px !important;">
            <div class="card-body body-alert d-flex flex-column">
              <h5 class="card-progress-title text-center alert-title">ALERTAS / NOTIFICAÇÕES</h5>
              <div class="linha" style="width: 44%;  height: 2px !important; margin-top:1px; margin-bottom: 20px"></div>

              <div class="father-div-progress">
                <div model="selectedListaNotificacao" v-for="itemNotificacao in this.listaNotificacao"
                  :key="itemNotificacao.id" :value="itemNotificacao.titulo">
                  <div class="alert-list">
                    <!-- Alerta 1 -->
                    <div v-if="itemNotificacao.visto === 'N'" class="alert-item d-flex align-items-center text-center">
                      <i style="padding-left: 6px !important;" class="fas fa-exclamation warning-icon mt-1"></i>
                      <a href="javascript:void(0)" @click="openModal(itemNotificacao)">
                        <span style="padding-left:3px !important;" class="alert-text"><strong>{{ itemNotificacao.titulo
                        }}</strong></span>
                      </a>
                    </div>

                    <!-- Alerta 2 -->
                    <div v-if="itemNotificacao.visto === 'S'" class="alert-item text-center">
                      <a href="javascript:void(0)" @click="openModal(itemNotificacao)">
                        <span class="alert-text">{{ itemNotificacao.titulo }}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>

      <section class="catalogo mt-5 web">
    <div class="container">
      <!-- Carousel wrapper -->
      <div id="carousel" class="carousel slide" data-mdb-ride="carousel">
        <!-- Indicators -->
        <ol class="carousel-indicators">
          <li data-mdb-target="#carousel" data-mdb-slide-to="0" class="active"></li>
          <li data-mdb-target="#carousel" data-mdb-slide-to="1"></li>
          <li data-mdb-target="#carousel" data-mdb-slide-to="2"></li>
        </ol>
        <!-- Inner -->
        <div class="carousel-inner pb-3">
          <!-- 1° Vendas -->
          <div class="carousel-item active">
            <h1>CATÁLOGO DE API - <span>VENDAS</span></h1>
            <hr class="divider">
            <div class="row">
              <div class="offset-md-1 col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="auto" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_auto.svg" alt="API de integração de Vendas do Seguro Automóvel"
                      title="API de integração de Vendas do Seguro Automóvel Tokio Marine"> 
                  </div>
                  <div class="card-produtos-body">
                    <h2>AUTOMÓVEL</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="residencial" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_residencial.svg"
                      alt="API de integração de Vendas do Seguro Residencial"
                      title="API de integração de Vendas do Seguro Residencial Tokio Marine">
                  </div>
                  <h2>RESIDENCIAL</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="imobiliario" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_imobiliario.svg"
                      alt="API de integração de Vendas do Seguro Imobiliário"
                      title="API de integração de Vendas do Seguro Imobiliário Tokio Marine">
                  </div>
                  <h2>IMOBILIÁRIO</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="condominio" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_condominio.svg"
                      alt="API de integração de Vendas do Seguro Condomínio"
                      title="API de integração de Vendas do Seguro Condomínio Tokio Marine">
                  </div>
                  <h2>CONDOMÍNIO</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="vida" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_vida.svg" alt="API de integração de Vendas do Seguro Vida"
                      title="API de integração de Vendas do Seguro Vida Tokio Marine">
                  </div>
                  <h2>VIDA</h2>
                </div>
              </div>
              <div class="offset-md-1 col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="aluguel" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_aluguel.svg" alt="API de integração de Vendas do Seguro Aluguel"
                      title="API de integração de Vendas do Seguro Aluguel Tokio Marine">
                  </div>
                  <h2>ALUGUEL</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="garantia" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_garantia.svg" alt="API de integração de Vendas do Seguro Garantia"
                      title="API de integração de Vendas do Seguro Garantia Tokio Marine">
                  </div>
                  <h2>GARANTIA</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="empresarial" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_empresarial.svg"
                      alt="API de integração de Vendas do Seguro Empresarial"
                      title="API de integração de Vendas do Seguro Empresarial Tokio Marine">
                  </div>
                  <h2>EMPRESARIAL</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="equipamentos" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_equipamentos.svg"
                      alt="API de integração de Vendas do Equipamentos"
                      title="API de integração de Vendas do Seguro Equipamentos Tokio Marine">
                  </div>
                  <h2>EQUIPAMENTOS</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="viagem" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_viagem.svg" alt="API de integração de Vendas do Equipamentos"
                      title="API de integração de Vendas do Seguro Equipamentos Tokio Marine">
                  </div>
                  <h2>VIAGEM</h2>
                </div>
              </div>
              <div class="offset-md-1 col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="cyber" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_cyber.svg" alt="API de integração de Vendas do Equipamentos"
                      title="API de integração de Vendas do Seguro Cyber Tokio Marine">
                  </div>
                  <h2>CYBER</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="eo" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_eo.svg" alt="API de integração de Vendas do Equipamentos"
                      title="API de integração de Vendas do Seguro E&O Tokio Marine">
                  </div>
                  <h2>E&O</h2>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img class="eosaude" src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_eo_saude.svg" alt="API de integração de Vendas do Equipamentos"
                      title="API de integração de Vendas do Seguro Equipamentos Tokio Marine">
                  </div>
                  <h2>E&O SAÚDE</h2>
                </div>
              </div>
            </div>
          </div>
          <!-- 2° Gestão -->
          <div class="carousel-item">
            <h1>CATÁLOGO DE API - <span>GESTÃO CARTEIRA</span></h1>
            <hr class="divider">
            <div class="row">
              <div class="col-6 col-md-3 col-lg-2 offset-md-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_apolice.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>APÓLICE</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_parcela.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>PARCELAS PAGAS</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_inadimplencia.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>INADIMPLÊNCIA</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_comissao.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>COMISSÃO</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6 col-md-3 col-lg-2 offset-md-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_renovacao.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>RENOVAÇÃO</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_pendencia.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>PENDÊNCIA</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_recusa.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>RECUSA</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_sinistro.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>SINISTRO</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 3° Pós venda -->
          <div class="carousel-item">
            <h1>CATÁLOGO DE API - <span>PÓS VENDAS</span></h1>
            <hr class="divider">
            <div class="row">
              <div class="col-6 col-md-3 col-lg-2 offset-md-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_apolice.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>APÓLICE</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_endosso.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>ENDOSSO</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_segurado.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>CARTÃO SEGURADO</h2>
                  </div>
                </div>
              </div>
              <div class="col-6 col-md-3 col-lg-2 d-flex justify-content-center">
                <div class="card-produtos">
                  <div class="card-produtos-header">
                    <img src="/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/ic_doc_boleto.svg">
                  </div>
                  <div class="card-produtos-body">
                    <h2>BOLETO</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Inner -->
        <!-- Controls -->
        <a class="carousel-control-prev" href="#carousel" role="button" data-mdb-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carousel" role="button" data-mdb-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="visually-hidden">Next</span>
        </a>
      </div>
      <!-- Carousel wrapper -->
    </div> <!-- fecha container -->
  </section>


    <!-- O Modal Rest Soap -->
    <div v-if="showModal" class="modal fade bd-example-modal-lg" id="myModal" tabindex="-1"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Alertas / Notificações </h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal"
              aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="col-12 col-sm-12" style="margin-left:-10px">
              <div class="form-outline mb-1">
                <div class="textarea-container mt-2 mb-4">
                  <h5 class="green-label">{{ this.modalData.titulo }}</h5>
                </div>
              </div>

              <div class="form-outline mb-1">
                <div class="textarea-container mt-4 mb-3 m-1">
                  <p style="white-space: pre-wrap">{{ this.modalData.descricao }}</p>
                </div>
              </div>

            </div>
          </div>

          <div class="mt-4" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div v-if="this.modalData.visto != 'N'" class="col-9">
              </div>
              <div v-if="this.modalData.visto === 'N'" class="col-6">
              </div>
              <div v-if="this.modalData.visto === 'N'" class="col-3">
                <button @click="salvarComoLido" type="button" id="gestao-carteira"
                  style="width: 100% !important;color:white !important" class="footer-button btn btn-primary active"
                  data-mdb-ripple-init>MARCAR COMO VISTO</button>
              </div>
              <div class="col-3">
                <button @click="closeModal" type="button" id="gestao-carteira"
                  style="width: 100% !important;color:#0F9476 !important" class="footer-button btn btn-secondary"
                  data-mdb-ripple-init>FECHAR</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<!-- Incluindo o Bootstrap JS -->
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"
  integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.3/umd/popper.min.js"
  integrity="sha384-ZMP7rVo3mIykV+2+9J3UJ46jBk0WLaUAdn689aCwoqbBJiSnjAK/l8WvCWPIPm49" crossorigin="anonymous"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/js/bootstrap.min.js"
  integrity="sha384-ChfqqxuZUCnJSK3+MXmPNIyE6ZbWh2IMqE241rYiqJxyMiZ6OW/JmZQ5stwEULTy" crossorigin="anonymous"></script>
<script>
import axios from 'axios';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import FormNotch from './FormNotch.vue';

import $ from 'jquery'; // Importando jQuery
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';

export default {
  data() {
    return {
      selectedListaConcluidas: [],
      listaConcluidas: [],
      selectedListaEmAndamento: [],
      listaEmAndamento: [],
      selectedListaNotificacao: [],
      listaNotificacao: [
        {
          "id": "1",
          "titulo": "Atualização disponível",
          "descricao": "Uma nova versão do catálogo foi publicada.",
          "visto": "N"
        },
        {
          "id": "2",
          "titulo": "Serviço atualizado",
          "descricao": "O serviço de venda residencial sofreu alterações.",
          "visto": "S"
        },
        {
          "id": "3",
          "titulo": "Ação necessária",
          "descricao": "Revise os atributos pendentes de aprovação.",
          "visto": "N"
        },
        {
          "id": "4",
          "titulo": "Processamento concluído",
          "descricao": "A importação da planilha foi finalizada com sucesso.",
          "visto": "S"
        },
        {
          "id": "5",
          "titulo": "Erro detectado",
          "descricao": "Foram encontrados problemas no catálogo durante a validação.",
          "visto": "N"
        }
      ]
      ,
      campos: [],
      modalData: [],
      showModal: false,
      iconMap: [],
      situacaoMap: [],

    };
  },
  components: {
    FormNotch
  },
  methods: {
    async acessarDocumentacao(api){
      alertUtils.alertAtencao('Para consultar a documentação da ' +  api + ', acesse o menu Catálogo de API.');
    },
    async openDoc(nome){
      window.open('/massificados/corporativo/gerenciador-parceiros-ui/portal-api/downloads/' + nome + '.doc');
    },
    async buscarConcluidas() {
      this.listaConcluidas = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/integracao/concluida`, false);
    },
    async buscarEmAndamento() {
      this.listaEmAndamento = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/integracao/listar-integracoes-andamento`, false);
    },
    async buscarNotificacoes() {
      this.listaNotificacao = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/notificacao-api/listar`, false);
      if (this.listaNotificacao != null) {
        // this.listaNotificacao = [
        //   {
        //     "id": "1",
        //     "titulo": "Atualização disponível",
        //     "descricao": "Uma nova versão do catálogo foi publicada.",
        //     "visto": "N"
        //   },
        //   {
        //     "id": "2",
        //     "titulo": "Serviço atualizado",
        //     "descricao": "O serviço de venda residencial sofreu alterações.",
        //     "visto": "S"
        //   },
        //   {
        //     "id": "3",
        //     "titulo": "Ação necessária",
        //     "descricao": "Revise os atributos pendentes de aprovação.",
        //     "visto": "N"
        //   },
        //   {
        //     "id": "4",
        //     "titulo": "Processamento concluído",
        //     "descricao": "A importação da planilha foi finalizada com sucesso.",
        //     "visto": "S"
        //   },
        //   {
        //     "id": "5",
        //     "titulo": "Erro detectado",
        //     "descricao": "Foram encontrados problemas no catálogo durante a validação.",
        //     "visto": "N"
        //   }
        // ];

        this.listaNotificacao = this.listaNotificacao.reverse();
      }
    },
    async salvarComoLido() {
      this.closeModal();

      const salvarLido = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/notificacao-api/visualizar/${this.modalData.id}`, false, 'Salvo como visto!');

      this.buscarNotificacoes();
    },
    async openModal(data) {
      this.showModal = true;
      this.modalData = data;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem
      $('body').css('padding-right', '0px');
    },
    formatarData(data) {
      const date = new Date(data);
      return date.toLocaleDateString('pt-BR');
    },
    async carregandoCards(loader) {

      // this.listaEmAndamento = [
      //   { id: 1, codigo: '001', codigoOperadora: 23, codigoProduto: 'PROD001', api: 'AUTOMÓVEL',      dataCriacao: '2025-06-24', situacao: 'APROVACAO-PRODUTOS' },
      //   { id: 2, codigo: '002', codigoOperadora: 24, codigoProduto: 'PROD002', api: 'RESIDENCIAL',    dataCriacao: '2025-06-24', situacao: 'DESENVOLVIMENTO' },
      //   { id: 3, codigo: '003', codigoOperadora: 25, codigoProduto: 'PROD003', api: 'IMOBILIÁRIO',    dataCriacao: '2025-06-24', situacao: 'HOMOLOGACAO-TI' },
      //   { id: 4, codigo: '004', codigoOperadora: 26, codigoProduto: 'PROD004', api: 'CONDOMÍNIO',     dataCriacao: '2025-06-24', situacao: 'APROVACAO-NEGOCIO' },
      //   { id: 5, codigo: '005', codigoOperadora: 27, codigoProduto: 'PROD005', api: 'VIDA',           dataCriacao: '2025-06-24', situacao: 'EM TESTES' },
      //   { id: 6, codigo: '006', codigoOperadora: 28, codigoProduto: 'PROD006', api: 'ALUGUEL',        dataCriacao: '2025-06-24', situacao: 'AGUARDANDO-INTEG' },
      //   { id: 7, codigo: '007', codigoOperadora: 29, codigoProduto: 'PROD007', api: 'GARANTIA',       dataCriacao: '2025-06-24', situacao: 'HOMOLOGACAO-USUARIO' },
      //   { id: 8, codigo: '008', codigoOperadora: 30, codigoProduto: 'PROD008', api: 'EMPRESARIAL',    dataCriacao: '2025-06-24', situacao: 'PLANEJAMENTO' },
      //   { id: 9, codigo: '009', codigoOperadora: 31, codigoProduto: 'PROD009', api: 'AGRO SAFRA',     dataCriacao: '2025-06-24', situacao: 'DESENVOLVIMENTO' },
      //   { id: 10, codigo: '010', codigoOperadora: 32, codigoProduto: 'PROD010', api: 'EQUIPAMENTOS',  dataCriacao: '2025-06-24', situacao: 'APROVACAO-PRODUTOS' },
      //   { id: 11, codigo: '011', codigoOperadora: 33, codigoProduto: 'PROD011', api: 'VIAGEM',        dataCriacao: '2025-06-24', situacao: 'ANALISE' },
      //   { id: 12, codigo: '012', codigoOperadora: 34, codigoProduto: 'PROD012', api: 'APÓLICE',       dataCriacao: '2025-06-24', situacao: 'EMITIDO' },
      //   { id: 13, codigo: '013', codigoOperadora: 35, codigoProduto: 'PROD013', api: 'PARCELAS PAGAS',dataCriacao: '2025-06-24', situacao: 'CONFERENCIA' },
      //   { id: 14, codigo: '014', codigoOperadora: 36, codigoProduto: 'PROD014', api: 'INADIMPLÊNCIA', dataCriacao: '2025-06-24', situacao: 'NEGOCIACAO' },
      //   { id: 15, codigo: '015', codigoOperadora: 37, codigoProduto: 'PROD015', api: 'COMISSÃO',      dataCriacao: '2025-06-24', situacao: 'PAGAMENTO' },
      //   { id: 16, codigo: '016', codigoOperadora: 38, codigoProduto: 'PROD016', api: 'RENOVAÇÃO',     dataCriacao: '2025-06-24', situacao: 'AGUARDANDO' },
      //   { id: 17, codigo: '017', codigoOperadora: 39, codigoProduto: 'PROD017', api: 'PENDÊNCIA',     dataCriacao: '2025-06-24', situacao: 'PENDENTE' },
      //   { id: 18, codigo: '018', codigoOperadora: 40, codigoProduto: 'PROD018', api: 'RECUSA',        dataCriacao: '2025-06-24', situacao: 'RECUSADO' },
      //   { id: 19, codigo: '019', codigoOperadora: 41, codigoProduto: 'PROD019', api: 'SINISTRO',      dataCriacao: '2025-06-24', situacao: 'ABERTO' },
      //   { id: 20, codigo: '020', codigoOperadora: 42, codigoProduto: 'PROD020', api: 'ENDOSSO',       dataCriacao: '2025-06-24', situacao: 'PROCESSANDO' },
      //   { id: 21, codigo: '021', codigoOperadora: 43, codigoProduto: 'PROD021', api: 'CARTÃO SEGURADO',dataCriacao: '2025-06-24', situacao: 'VALIDANDO' },
      //   { id: 22, codigo: '022', codigoOperadora: 44, codigoProduto: 'PROD022', api: 'BOLETO',        dataCriacao: '2025-06-24', situacao: 'GERADO' }
      // ];

      // this.listaConcluidas = [
      //   { codigo: '001', codigoProduto: 'PROD001', api: 'AUTOMÓVEL',       qtd_corretor: 12, produto: 'Seguro Automóvel' },
      //   { codigo: '002', codigoProduto: 'PROD002', api: 'RESIDENCIAL',     qtd_corretor: 8,  produto: 'Seguro Residencial' },
      //   { codigo: '003', codigoProduto: 'PROD003', api: 'IMOBILIÁRIO',     qtd_corretor: 5,  produto: 'Seguro Imobiliário' },
      //   { codigo: '004', codigoProduto: 'PROD004', api: 'CONDOMÍNIO',      qtd_corretor: 6,  produto: 'Seguro Condomínio' },
      //   { codigo: '005', codigoProduto: 'PROD005', api: 'VIDA',            qtd_corretor: 20, produto: 'Seguro de Vida' },
      //   { codigo: '006', codigoProduto: 'PROD006', api: 'ALUGUEL',         qtd_corretor: 4,  produto: 'Seguro Aluguel' },
      //   { codigo: '007', codigoProduto: 'PROD007', api: 'GARANTIA',        qtd_corretor: 10, produto: 'Seguro Garantia' },
      //   { codigo: '008', codigoProduto: 'PROD008', api: 'EMPRESARIAL',     qtd_corretor: 7,  produto: 'Seguro Empresarial' },
      //   { codigo: '009', codigoProduto: 'PROD009', api: 'AGRO SAFRA',      qtd_corretor: 15, produto: 'Seguro Agro Safra' },
      //   { codigo: '010', codigoProduto: 'PROD010', api: 'EQUIPAMENTOS',    qtd_corretor: 9,  produto: 'Seguro Equipamentos' },
      //   { codigo: '011', codigoProduto: 'PROD011', api: 'VIAGEM',          qtd_corretor: 11, produto: 'Seguro Viagem' },
      //   { codigo: '012', codigoProduto: 'PROD012', api: 'APÓLICE',         qtd_corretor: 18, produto: 'Gestão de Apólices' },
      //   { codigo: '013', codigoProduto: 'PROD013', api: 'PARCELAS PAGAS',  qtd_corretor: 6,  produto: 'Controle de Parcelas' },
      //   { codigo: '014', codigoProduto: 'PROD014', api: 'INADIMPLÊNCIA',   qtd_corretor: 3,  produto: 'Gestão de Inadimplência' },
      //   { codigo: '015', codigoProduto: 'PROD015', api: 'COMISSÃO',        qtd_corretor: 9,  produto: 'Gestão de Comissão' },
      //   { codigo: '016', codigoProduto: 'PROD016', api: 'RENOVAÇÃO',       qtd_corretor: 14, produto: 'Gestão de Renovações' },
      //   { codigo: '017', codigoProduto: 'PROD017', api: 'PENDÊNCIA',       qtd_corretor: 2,  produto: 'Gestão de Pendências' },
      //   { codigo: '018', codigoProduto: 'PROD018', api: 'RECUSA',          qtd_corretor: 1,  produto: 'Gestão de Recusas' },
      //   { codigo: '019', codigoProduto: 'PROD019', api: 'SINISTRO',        qtd_corretor: 16, produto: 'Gestão de Sinistros' },
      //   { codigo: '020', codigoProduto: 'PROD020', api: 'ENDOSSO',         qtd_corretor: 7,  produto: 'Gestão de Endossos' },
      //   { codigo: '021', codigoProduto: 'PROD021', api: 'CARTÃO SEGURADO', qtd_corretor: 5,  produto: 'Gestão de Cartão Segurado' },
      //   { codigo: '022', codigoProduto: 'PROD022', api: 'BOLETO',          qtd_corretor: 13, produto: 'Gestão de Boletos' }
      // ];

      
      this.iconMap = [
        { key:'AUTOMÓVEL',     img:'icon_carro.svg',        label:'AUTOMÓVEL',     codes:[7],                   includes:['AUTOMÓVEL'],                      style:'', customClass:'' },
        { key:'RESIDENCIAL',   img:'icon_residencial.svg',  label:'RESIDENCIAL',   codes:[14],                  includes:['RESIDENCIAL'],                   style:'', customClass:'' },
        { key:'IMOBILIÁRIO',   img:'icon_imobiliario.svg',  label:'IMOBILIÁRIO',   codes:[43,44],               includes:['IMOBILIARIO','IMOBILIÁRIO'],     style:'', customClass:'card-img--mt5' },
        { key:'CONDOMÍNIO',    img:'icon_condominio.svg',   label:'CONDOMÍNIO',    codes:[12],                  includes:['CONDOMÍNIO','CONDOMINIO'],       style:'', customClass:'' },
        { key:'VIDA',          img:'ic_vida.svg',           label:'VIDA',          codes:[47],                  includes:['VIDA'],                          style:'', customClass:'card-img--mt5' , path:'portal-api' },
        { key:'ALUGUEL',       img:'icon_aluguel.svg',      label:'ALUGUEL',       codes:[55,56,72,73],         includes:['ALUGUEL'],                       style:'', customClass:'card-img--mt5' },
        { key:'GARANTIA',      img:'icon_garantia.svg',     label:'GARANTIA',      codes:[7503,7602,7603],      includes:['GARANTIA'],                      style:'', customClass:'mt-5' },
        { key:'EMPRESARIAL',   img:'icon_empresarial.svg',  label:'EMPRESARIAL',   codes:[62,63],               includes:['EMPRESARIAL'],                   style:'', customClass:'mt-53' },
        { key:'AGRO SAFRA',    img:'icon_agro.svg',         label:'AGRO',          codes:[103],                 includes:['AGRO SAFRA','AGROSAFRA'],        style:'', customClass:'card-img--mt5' },
        { key:'EQUIPAMENTOS',  img:'icon_equipamentos.svg', label:'EQUIPAMENTOS',  codes:[10005,10006,10017],   includes:['EQUIPAMENTOS'],                  style:'', customClass:'' },
        { key:'VIAGEM',        img:'icon_viagem.svg',       label:'VIAGEM',        codes:[108],                 includes:['VIAGEM'],                        style:'', customClass:'card-img--mt5' },
        { key:'APÓLICE',       img:'ic_apolice.svg',        label:'APÓLICE',                                      includes:['APÓLICE','APOLICE'],            style:'', customClass:'card-img--mt5', path:'portal-api' },
        { key:'PARCELAS PAGAS',img:'ic_apolice.svg',        label:'PARCELAS PAGAS',                               includes:['PARCELAS PAGAS'],               style:'', customClass:'card-img--mt5' },
        { key:'INADIMPLÊNCIA', img:'ic_apolice.svg',        label:'INADIMPLÊNCIA',                                includes:['INADIMPLÊNCIA','INADIMPLENCIA'],style:'', customClass:'' },
        { key:'COMISSÃO',      img:'ic_apolice.svg',        label:'COMISSÃO',                                     includes:['COMISSÃO','COMISSAO'],          style:'', customClass:'card-img--mt5' },
        { key:'RENOVAÇÃO',     img:'ic_apolice.svg',        label:'RENOVAÇÃO',                                    includes:['RENOVAÇÃO','RENOVACAO'],        style:'', customClass:'' },
        { key:'PENDÊNCIA',     img:'ic_apolice.svg',        label:'PENDÊNCIA',                                    includes:['PENDÊNCIA','PENDENCIA'],        style:'', customClass:'card-img--mt5' },
        { key:'RECUSA',        img:'ic_apolice.svg',        label:'RECUSA',                                       includes:['RECUSA'],                       style:'', customClass:'card-img--mt5' },
        { key:'SINISTRO',      img:'ic_apolice.svg',        label:'SINISTRO',                                     includes:['SINISTRO'],                     style:'', customClass:'card-img--mt5' },
        { key:'ENDOSSO',       img:'ic_apolice.svg',        label:'ENDOSSO',                                      includes:['ENDOSSO'],                      style:'', customClass:'card-img--mt5' },
        { key:'CARTÃO SEGURADO', img:'ic_apolice.svg',      label:'CARTÃO SEGURADO',                              includes:['CARTÃO SEGURADO','CARTAO SEGURADO'], style:'', customClass:'card-img--mt5' },
        { key:'BOLETO',        img:'ic_doc_boleto.svg',     label:'BOLETO',                                       includes:['BOLETO'],                       style:'', customClass:'grayscale', path:'portal-api' },
      ];

      this.situacaoMap = [
        {
          key: 'APROVACAO-PRODUTOS',
          label: 'APROVAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:140% !important'
        },
        {
          key: 'CONFIGURACAO-ACEITE',
          label: 'CONFIGURAÇÃO ACEITE',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'DESENVOLVINENTO',
          label: 'DESENVOLVINENTO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'HOMOLOGACAO-TI',
          label: 'HOMOLOGAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'HOMOLOGACAO-PRODUTOS',
          label: 'HOMOLOGAÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        },
        {
          key: 'CONFIGURACAO-PRODUCAO',
          label: 'CONFIG. PRODUÇÃO',
          style: 'margin-top: 10% !important; margin-left: -45px;width:150% !important'
        }
      ]

      if(loader){
        $('.father-div').css('display','none');
        $('.father-div-progress').css('display','none');
        $('.father-div-alert').css('display','none');

        $('.card-completed-title')[0].setAttribute('style', 'margin-top: -57% !important');

        $('.card-progress-title')[0].setAttribute('style', 'margin-top: 4% !important');

        $('.alert-title')[0].setAttribute('style', 'margin-top: -47% !important');
      } else {
        $('.father-div').css('display','block');
        $('.father-div-progress').css('display','block');
        $('.father-div-alert').css('display','block');

        $('.card-completed-title')[0].setAttribute('style', 'margin-top: 3% !important');

        $('.card-progress-title')[0].setAttribute('style', 'margin-top: 62% !important');

        $('.alert-title')[0].setAttribute('style', 'margin-top: -1% !important');
      }
    },
    iconFor(item) {
      if (!item) return null; 
    
      const code = Number(item.codigoProduto);
      const prodName = this._normalize(item.produto);
      

      let found = this.iconMap.find(m => Array.isArray(m.codes) && m.codes.includes(code));
      if (found) return found;


      found = this.iconMap.find(m =>
        Array.isArray(m.includes) &&
        m.includes.some(inc => prodName.includes(this._normalize(inc)))
      );
      if (found) return found;


      found = this.iconMap.find(m => prodName.includes(this._normalize(m.key)));
      if (found) return found;


      return null;
    },
    safeIcon(item) {
      const ic = this.iconFor(item);
      // garante um objeto mesmo quando iconFor retornar null
      return ic || { img: '', label: '', style: '', path: 'consulta' };
    },

    _normalize(str) {
      return String(str || '')
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
    },
  iconsForApi(item) {
    if (!item || !item.api) return [];
    const api = this._normalize(item.api);

    return this.iconMap.filter(ic => api.includes(this._normalize(ic.key)));
  }

  },

  async mounted() {
    
    loaderUtils.addLoarder();

    this.carregandoCards(true);

    // Aguarda as 3 funções concluírem
    await Promise.all([
        this.buscarConcluidas(),
        this.buscarEmAndamento(),
        this.buscarNotificacoes()
    ]);

    loaderUtils.removeLoader();

    this.carregandoCards(false);
  }
}
</script>

<style scoped>
.cards {
  margin-top: -1.6% !important
}

.title-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
  margin-top: 4%;
  margin-bottom: -0.5%;
}

.subtitle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5vh;
  margin-top: 1%;
  margin-bottom: 1.5%;
  margin-right: 2%;
}

nav {
  margin-top: -2%;
  background-color: transparent !important;
  padding: 0px 0px 0px 0px;
  width: 16%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0), 0 3px 1px -2px rgba(0, 0, 0, 0), 0 1px 5px 0 rgba(0, 0, 0, 0) !important;
  margin-left: 41%;
}

.btn-acoes {
  margin-top: -13px !important;
}

.dt-search {
  display: none !important;
}

.dt-input {
  width: 9rem !important;
  height: 15px !important;
}

div.dt-paging nav {
  height: 36px !important;
  width: -webkit-fill-available !important;
}

nav,
nav .nav-wrapper i,
nav a.sidenav-trigger,
nav a.sidenav-trigger i {
  line-height: 21px !important;
}

.custom-modal .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
}

.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal-content {
  background-color: #fff;
  /* Cor de fundo do modal */
  padding: 20px;
  border-radius: 8px;
}

.modal {
  display: block;
  max-height: 100rem !important;
  background: transparent !important;
}

.btn-danger {
  background: linear-gradient(254deg, #23c5ae 0%, #19a38f 100%) !important;
}

.dt-paging-button.current {
  background: #2FC8B2 !important;
  color: white !important;
}

input.form-control {
  padding-left: 10px !important;
  box-sizing: border-box !important;
  /* Ajusta o box model para incluir padding e borda */
  border: 1px solid #ccc !important;
  /* Borda */
  width: 100% !important;
  /* Largura total, evita vazamento */
}

/* Para navegadores baseados em Webkit (Chrome, Safari, Edge, etc.) */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  /* Remove as setas */
  margin: 0;
}

/* Para Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  /* Remove as setas no Firefox */
}

.search-span {
  padding: 15px 10px 20px;
}

.fa-search.me-1 {
  padding-top: 2px;
}

.search-button {
  padding-bottom: 2.6rem !important;
  width: 11rem !important;
}

.card-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: -17%;
}

.card-progress-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: 3%;
  padding-top: 0% !important;
  margin-top: 66% !important;
}

.card-completed-title {
  font-size: 18px !important;
  color: #0B9274 !important;
  /* Cor do texto */
  text-align: center;
  /* Centraliza o texto */
  margin-top: 3%;
  padding-top: 60% !important;
  margin-top: 1% !important;
}

.card {
  margin-bottom: 20px;
  /* Menos espaçamento entre os cards */
  padding-bottom: 18% !important;
  border-radius: 4% !important;
  width: 30% !important;
  margin-top: 0% !important;
  border: none;
  box-shadow: 0px 0px 30px rgb(0 0 0 / 6%);
}

.linha {
  width: 46%;
  /* Largura total da linha */
  height: 2px;
  /* Linha fina (espessura de 2px) */
  background: linear-gradient(to right, #B9B970 40%, #1C9674 60%);
  margin: 10px auto;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  margin-left: 29%
}

.linha-api {
  width: 10%;
  /* Largura total da linha */
  height: 2px;
  /* Linha fina (espessura de 2px) */
  background: linear-gradient(to right, #B9B970 40%, #1C9674 60%);
  margin: 0px auto;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  margin-left: 45%;
  margin-top: -0.8%;
}

/* .banner {
  width: 100%;
  height: 141px;
  color: white;
  padding-top: 0.58rem;
  position: relative;
  background: url("../../../public/massificados/corporativo/gerenciador-parceiros-ui/portal-api/img/banner.png") center center no-repeat;
} */

.banner {
  width: 100%;
  height: 141px;
  color: white;
  padding-top: 0.58rem;
  position: relative;
  background: url("../../../public/radar/img/banner-2.jpg") center center no-repeat;
}

.icon-line {
  font-size: 1px !important;
  width: 31%;
  color: white !important;
  margin: 0px auto 25px;
  /* Centraliza a linha com espaçamento de 10px para cima e para baixo */
  /* margin-top: 10% */
}

.card-footer {
  text-align: center;
  padding-top: 14px !important;
  background-color: white !important;
  color: #117F63 !important;
  padding-bottom: 11% !important;
  font-size: 12px;
  text-align: center !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
}

.main-div {
  margin-left: 9% !important;
  width: 91%;
  margin-bottom: -11% !important;
  max-height: 40% !important;
}

.main-div-api {
  margin-left: 7% !important;
  width: 71%;
  margin-bottom: -11% !important;
  max-height: 40% !important;
}

.sub-div {
  margin-left: 3% !important;
  width: 91%;
  margin-top: 3% !important;
}

.body-alert {
  display: flex;
  flex-direction: column;
  height: 230%;
  /* Ocupa toda a altura disponível do card */
  padding: 15px;
  margin-top: 57%;
}

.linha {
  border-top: 1px solid #ccc;
  /* Linha cinza */
  margin-bottom: 15px;
  /* Espaçamento entre a linha e a lista */
}

.alert-list {
  flex-grow: 2;
  /* Aumenta o espaço ocupado pela lista de alertas */
  overflow-y: auto;
  /* Habilita a rolagem quando os itens ultrapassarem a altura */
  max-height: 100%;
  /* Garante que a lista não ultrapasse a altura do card */
}

.alert-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* Alinha o conteúdo à esquerda */
  margin-bottom: 10px;
  /* Espaçamento entre os itens */
  padding-bottom: 10px;
  /* Espaço antes da linha */
  border-bottom: 1px solid #ccc;
  /* Linha cinza abaixo de cada item */
}

.alert-item a {
  text-decoration: none;
  color: inherit;
}

.warning-icon {
  color: #ffc107;
  /* Cor do ícone de alerta (amarelo) */
  margin-right: 5px;
  /* Espaçamento entre o ícone e o texto */
}

.alert-text strong {
  font-weight: bold;
  /* Alerta em negrito */
}

.warning-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  /* Tamanho do círculo */
  height: 18px;
  /* Tamanho do círculo */
  border-radius: 50%;
  /* Faz o ícone ficar em formato circular */
  /* background: linear-gradient(to right, #1C9674 0%, #1C9674 50%, #B9B970 100%); */
  /* Gradiente suave entre o verde e o amarelo */
  background: linear-gradient(52deg, #1C9674 0%, #B9B970 100%);
  color: white;
  /* Cor do ícone (branca para contrastar com o fundo) */
  font-size: 12px;
  /* Tamanho do ícone */
  padding: 5px;
  /* Ajuste do espaçamento interno, se necessário */
}


.alert-text {
  padding-left: 35px;
  font-size: 12px;
  text-align: left;
  /* Alinha o texto à esquerda dentro de seu espaço */
}

.text-center {
  text-align: center;
}

.green-label {
  color: #0B9274;
  /* Cor do rótulo */
  font-weight: 700;
  background: white;
  /* Fundo branco para sobrepor a linha do textarea */
  margin-left: 3px;
  /* Ajusta a posição horizontal conforme necessário */
}

.card-subtext {
  padding-left: 2px;
  font-weight: normal;
  font-size: 11px
}

.card-img {
  width: 30px !important;
  /* margin-left: 24% !important; */
  /* margin-top: 84%; */
}

.card-body {
  text-align: center;
  padding: 1rem 1rem 2rem 1rem;
}

.card-img-text {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
}

.card-img-text-life {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
  padding-left: 2px !important
}

.card-img-text-safra {
  font-size: 13px;
  color: gray !important;
  font-style: normal;
  width: 180%;
  margin-left: -5px;
}

.card-intern {
  /* height: 10px !important; */
  /* margin-left: 0% !important; */
  margin-bottom: 1rem !important;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #ccc;
  border-radius: .8rem;
}

.father-div {
  margin-top: 0% !important;
  overflow-y: auto !important;
  max-height: 70% !important;
  height: 235px !important;
  width: 100% !important;
  overflow-x: hidden !important
}

.father-div-progress {
  overflow-y: auto !important;
  max-height: 70% !important;
  height: 235px !important;
  width: 100% !important;
  overflow-x: hidden !important;
  padding: 0 .5rem 0 0;
}

.card-icons {
  width: 140px !important;
  background-color: #F6F6F6 !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  border-top-left-radius: 14% !important;
  border-bottom-left-radius: 14% !important;
  border-right: 1px solid #ccc;
  padding: .6rem;
}

.card-info {
  background: transparent;
  padding-top: .7rem;
  width: 75%;
}

.card-content {
  height: 350px !important;
  width: 350px !important;
}

.carousel-item.active {
  width: 78% !important;
  max-width: 82% !important;
  margin-left: 13%;
}

.carousel-item {
  width: 78% !important;
  max-width: 82% !important;
  margin-left: 13%;
}

.title {
  font-size: 27px !important;
}

.title span {
  font-size: 15px !important;
}

.card-text {
  font-size: .75rem;
}

.card-footer {
  border-bottom-left-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
}

.btd {
  margin-top: 10px !important;
  margin-bottom: -10px !important;
}

.msg-integracoes {
  border: 1px solid #ccc;
  border-radius: .8rem;
  margin-left: .6rem;
  padding: .5rem
}


section.catalogo {
    position: relative;
    top: -1rem;
}

section.catalogo h1 {
    text-align: center;
    width: 100%;
    font-size: 1.7rem;
    color: var(--cor-primaria);
}

section.catalogo h1 span {
    font-weight: 100 !important;
}

section.catalogo p {
    text-align: center;
    font-size: 1.5rem;
    font-weight: 200;
    margin-bottom: 0;
    color: #888;
}

section.catalogo .card-produtos {
    width: 100%;
    min-height: 184px;
    background: #fff;
    margin: 2rem auto 0;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0px 0px 30px rgb(0 0 0 / 6%);
    display: block;
}

section.catalogo .card-produtos-header {
    height: 118px;
    padding: 1.5rem 0;
    background: linear-gradient(203deg, #B9B970 17%, #019074);
    border-radius: .8rem .8rem 0 0;
}

section.catalogo .card-produtos-header .auto {
    width: 62px;
    height: auto;
    position: relative;
    top: 11px;
    transform: scale(.95);
}

section.catalogo .card-produtos-header .residencial {
    width: 60px;
    height: auto;
}

section.catalogo .card-produtos-header .imobiliario {
    width: 61px;
    height: auto;
}

section.catalogo .card-produtos-header .condominio {
    width: 63px;
    height: auto;
    position: relative;
    top: 10px;
}

section.catalogo .card-produtos-header .vida {
    width: 75px;
    height: auto;
    position: relative;
    top: -1px;
}

section.catalogo .card-produtos-header .aluguel {
    width: 59px;
    height: auto;
}

section.catalogo .card-produtos-header .garantia {
    width: 52px;
    height: auto;
    top: -2px;
    position: relative;
}

section.catalogo .card-produtos-header .empresarial {
    width: 65px;
    height: auto;
}

section.catalogo .card-produtos-header .agro {
    width: 63px;
    height: auto;
}

section.catalogo .card-produtos-header .equipamentos {
    width: 63px;
    height: auto;
}

section.catalogo .card-produtos-header .viagem {
    width: 80px;
    height: auto;
    position: relative;
    top: 12px;
}

section.catalogo .card-produtos-header .cyber {
    width: 80px;
    height: auto;
    position: relative;
    top: 0;
}

section.catalogo .card-produtos-header .eo {
   width: 64px;
    height: auto;
    position: relative;
    top: -4px;
}

section.catalogo .card-produtos-header .eosaude {
   width: 64px;
    height: auto;
    position: relative;
    top: -4px;
}

section.catalogo .card-produtos h2 {
    color: var(--cor-primaria);
    font-size: .9rem;
    margin-top: 1.3rem;
}

section.catalogo .card-produtos ul {
    list-style-type: none;
    margin: 1rem 0 0;
    padding: 0px 0px 0px 1.5rem;
    font-size: 14px;
    text-align: left;
}

section.catalogo .card-produtos p {
    margin: 1rem 0px 0px;
    padding: 0 1rem;
    font-size: 14px;
}

section.catalogo .card-produtos-body {
    padding: 0;
}

section.catalogo .card-produtos-footer {
    padding: 1rem;
    border: none !important;
}

section.catalogo .card-produtos li i {
    margin-right: .3rem;
    color: var(--cor-primaria)
}

section.catalogo.api {
    position: relative;
    top: 0rem;
    margin: 1rem 0 4rem 0;
}


#carousel {
    margin-bottom: 4rem;
}

.carousel-control-next,
.carousel-control-prev {
    color: var(--cor-primaria) !important;
}

.carousel-indicators [data-mdb-target] {
    background-color: var(--cor-primaria) !important;
}

#carousel h1,
#carousel .passos p {
    text-align: center;
}

#carousel .divider {
    width: 100px;
    height: 2px;
    border: none;
    background: linear-gradient(var(--cor-degrade));
    text-align: center;
    opacity: 1;
    display: inline-block;
    position: relative;
    left: 50%;
    margin-left: -50px;
    margin-top: 0.5rem;
}

.carousel-indicators {
    bottom: -3rem;
}

.carousel-control-next-icon, .carousel-control-prev-icon{background-image: none}

@import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/style.css';
</style>
